module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-2-orange-b056f5c790407970797c2459b0ee7713.svg";